export default "__VITE_ASSET__D0HA3wgc__"